// Shared location and service data for SEO pages
// Used by LocationServicePage, ServiceArea, and other components

export const LOCATIONS = {
  // Städte
  'noerten-hardenberg': { name: 'Nörten-Hardenberg', type: 'Flecken', distance: 0, region: 'Landkreis Northeim' },
  'goettingen': { name: 'Göttingen', type: 'Stadt', distance: 10, region: 'Landkreis Göttingen' },
  'bovenden': { name: 'Bovenden', type: 'Flecken', distance: 8, region: 'Landkreis Göttingen' },
  'northeim': { name: 'Northeim', type: 'Kreisstadt', distance: 10, region: 'Landkreis Northeim' },
  'einbeck': { name: 'Einbeck', type: 'Stadt', distance: 25, region: 'Landkreis Northeim' },
  'hardegsen': { name: 'Hardegsen', type: 'Stadt', distance: 8, region: 'Landkreis Northeim' },
  'moringen': { name: 'Moringen', type: 'Stadt', distance: 15, region: 'Landkreis Northeim' },
  'uslar': { name: 'Uslar', type: 'Stadt', distance: 25, region: 'Landkreis Northeim' },
  'katlenburg-lindau': { name: 'Katlenburg-Lindau', type: 'Gemeinde', distance: 12, region: 'Landkreis Northeim' },
  'dassel': { name: 'Dassel', type: 'Stadt', distance: 22, region: 'Landkreis Northeim' },
  'kalefeld': { name: 'Kalefeld', type: 'Gemeinde', distance: 25, region: 'Landkreis Northeim' },
  'bodenfelde': { name: 'Bodenfelde', type: 'Flecken', distance: 28, region: 'Landkreis Northeim' },
  'adelebsen': { name: 'Adelebsen', type: 'Flecken', distance: 15, region: 'Landkreis Göttingen' },
  'gleichen': { name: 'Gleichen', type: 'Gemeinde', distance: 18, region: 'Landkreis Göttingen' },
  'friedland': { name: 'Friedland', type: 'Gemeinde', distance: 20, region: 'Landkreis Göttingen' },
  'rosdorf': { name: 'Rosdorf', type: 'Gemeinde', distance: 15, region: 'Landkreis Göttingen' },
  'ebergoetzen': { name: 'Ebergötzen', type: 'Gemeinde', distance: 22, region: 'Landkreis Göttingen' },
  'bad-gandersheim': { name: 'Bad Gandersheim', type: 'Stadt', distance: 30, region: 'Landkreis Northeim' },
  'dransfeld': { name: 'Dransfeld', type: 'Stadt', distance: 18, region: 'Landkreis Göttingen' },
  'hann-muenden': { name: 'Hann. Münden', type: 'Stadt', distance: 28, region: 'Landkreis Göttingen' },
  // Ortsteile Göttingen
  'weende': { name: 'Weende', type: 'Ortsteil', distance: 8, region: 'Göttingen' },
  'grone': { name: 'Grone', type: 'Ortsteil', distance: 12, region: 'Göttingen' },
  'geismar': { name: 'Geismar', type: 'Ortsteil', distance: 12, region: 'Göttingen' },
  'nikolausberg': { name: 'Nikolausberg', type: 'Ortsteil', distance: 10, region: 'Göttingen' },
  'elliehausen': { name: 'Elliehausen', type: 'Ortsteil', distance: 10, region: 'Göttingen' },
  'esebeck': { name: 'Esebeck', type: 'Ortsteil', distance: 9, region: 'Göttingen' },
  'holtensen': { name: 'Holtensen', type: 'Ortsteil', distance: 11, region: 'Göttingen' },
  // Ortsteile Bovenden
  'lenglern': { name: 'Lenglern', type: 'Ortsteil', distance: 6, region: 'Bovenden' },
  'eddigehausen': { name: 'Eddigehausen', type: 'Ortsteil', distance: 5, region: 'Bovenden' },
  'reyershausen': { name: 'Reyershausen', type: 'Ortsteil', distance: 7, region: 'Bovenden' },
  'spanbeck': { name: 'Spanbeck', type: 'Ortsteil', distance: 8, region: 'Bovenden' },
  'billingshausen': { name: 'Billingshausen', type: 'Ortsteil', distance: 6, region: 'Bovenden' },
  // Ortsteile Northeim
  'sudheim': { name: 'Sudheim', type: 'Ortsteil', distance: 8, region: 'Northeim' },
  'hoeckelheim': { name: 'Höckelheim', type: 'Ortsteil', distance: 12, region: 'Northeim' },
  'hollenstedt': { name: 'Hollenstedt', type: 'Ortsteil', distance: 14, region: 'Northeim' },
  'imbshausen': { name: 'Imbshausen', type: 'Ortsteil', distance: 13, region: 'Northeim' },
  'langenholtensen': { name: 'Langenholtensen', type: 'Ortsteil', distance: 15, region: 'Northeim' },
  // Ortsteile Nörten-Hardenberg
  'angerstein': { name: 'Angerstein', type: 'Ortsteil', distance: 3, region: 'Nörten-Hardenberg' },
  'bishausen': { name: 'Bishausen', type: 'Ortsteil', distance: 4, region: 'Nörten-Hardenberg' },
  'elvese': { name: 'Elvese', type: 'Ortsteil', distance: 5, region: 'Nörten-Hardenberg' },
  'luetgenrode': { name: 'Lütgenrode', type: 'Ortsteil', distance: 4, region: 'Nörten-Hardenberg' },
  'parensen': { name: 'Parensen', type: 'Ortsteil', distance: 6, region: 'Nörten-Hardenberg' },
  'sudershausen': { name: 'Sudershausen', type: 'Ortsteil', distance: 5, region: 'Nörten-Hardenberg' },
  'wolbrechtshausen': { name: 'Wolbrechtshausen', type: 'Ortsteil', distance: 7, region: 'Nörten-Hardenberg' },
  // Weitere Dörfer
  'gladebeck': { name: 'Gladebeck', type: 'Ortsteil', distance: 10, region: 'Hardegsen' },
  'hillerse': { name: 'Hillerse', type: 'Gemeinde', distance: 16, region: 'Landkreis Northeim' },
  'juhnde': { name: 'Jühnde', type: 'Gemeinde', distance: 14, region: 'Landkreis Göttingen' },
  'scheden': { name: 'Scheden', type: 'Gemeinde', distance: 16, region: 'Landkreis Göttingen' },
  'dramfeld': { name: 'Dramfeld', type: 'Ortsteil', distance: 14, region: 'Rosdorf' },
  'niedernjesa': { name: 'Niedernjesa', type: 'Ortsteil', distance: 13, region: 'Friedland' },
  'gross-schneen': { name: 'Groß Schneen', type: 'Ortsteil', distance: 15, region: 'Friedland' },
  'klein-schneen': { name: 'Klein Schneen', type: 'Ortsteil', distance: 14, region: 'Friedland' },
  'reinhausen': { name: 'Reinhausen', type: 'Ortsteil', distance: 16, region: 'Gleichen' },
  'benniehausen': { name: 'Benniehausen', type: 'Ortsteil', distance: 17, region: 'Gleichen' },
  'diemarden': { name: 'Diemarden', type: 'Ortsteil', distance: 15, region: 'Gleichen' },
  'kerstlingerode': { name: 'Kerstlingerode', type: 'Ortsteil', distance: 18, region: 'Gleichen' },
  // Katlenburg-Lindau
  'katlenburg': { name: 'Katlenburg', type: 'Ortsteil', distance: 12, region: 'Katlenburg-Lindau' },
  'lindau': { name: 'Lindau', type: 'Ortsteil', distance: 14, region: 'Katlenburg-Lindau' },
  'gillersheim': { name: 'Gillersheim', type: 'Ortsteil', distance: 13, region: 'Katlenburg-Lindau' },
  'berka': { name: 'Berka', type: 'Ortsteil', distance: 15, region: 'Katlenburg-Lindau' },
  'elvershausen': { name: 'Elvershausen', type: 'Ortsteil', distance: 14, region: 'Katlenburg-Lindau' },
  'suterode': { name: 'Suterode', type: 'Ortsteil', distance: 16, region: 'Katlenburg-Lindau' },
  'wachenhausen': { name: 'Wachenhausen', type: 'Ortsteil', distance: 15, region: 'Katlenburg-Lindau' },
  // Moringen
  'fredelsloh': { name: 'Fredelsloh', type: 'Ortsteil', distance: 18, region: 'Moringen' },
  'grossenrode': { name: 'Großenrode', type: 'Ortsteil', distance: 17, region: 'Moringen' },
  'nienhagen': { name: 'Nienhagen', type: 'Ortsteil', distance: 16, region: 'Moringen' },
  'lutterbeck': { name: 'Lutterbeck', type: 'Ortsteil', distance: 19, region: 'Moringen' },
  'oldenrode': { name: 'Oldenrode', type: 'Ortsteil', distance: 18, region: 'Moringen' },
  // Adelebsen
  'barterode': { name: 'Barterode', type: 'Ortsteil', distance: 13, region: 'Adelebsen' },
  'eberhausen': { name: 'Eberhausen', type: 'Ortsteil', distance: 14, region: 'Adelebsen' },
  'guentersen': { name: 'Güntersen', type: 'Ortsteil', distance: 16, region: 'Adelebsen' },
  'loedingsen': { name: 'Lödingsen', type: 'Ortsteil', distance: 15, region: 'Adelebsen' },
  'wibbecke': { name: 'Wibbecke', type: 'Ortsteil', distance: 17, region: 'Adelebsen' },
  // Dassel
  'markoldendorf': { name: 'Markoldendorf', type: 'Ortsteil', distance: 20, region: 'Dassel' },
  'lauenberg': { name: 'Lauenberg', type: 'Ortsteil', distance: 22, region: 'Dassel' },
  'sievershausen': { name: 'Sievershausen', type: 'Ortsteil', distance: 24, region: 'Dassel' },
  // Duderstadt
  'duderstadt': { name: 'Duderstadt', type: 'Stadt', distance: 25, region: 'Landkreis Göttingen' },
  'breitenberg': { name: 'Breitenberg', type: 'Ortsteil', distance: 27, region: 'Duderstadt' },
  'brochthausen': { name: 'Brochthausen', type: 'Ortsteil', distance: 26, region: 'Duderstadt' },
  'fuhrbach': { name: 'Fuhrbach', type: 'Ortsteil', distance: 24, region: 'Duderstadt' },
  'gerblingerode': { name: 'Gerblingerode', type: 'Ortsteil', distance: 23, region: 'Duderstadt' },
  'hilkerode': { name: 'Hilkerode', type: 'Ortsteil', distance: 28, region: 'Duderstadt' },
  'immingerode': { name: 'Immingerode', type: 'Ortsteil', distance: 26, region: 'Duderstadt' },
  'langenhagen': { name: 'Langenhagen', type: 'Ortsteil', distance: 27, region: 'Duderstadt' },
  'mingerode': { name: 'Mingerode', type: 'Ortsteil', distance: 25, region: 'Duderstadt' },
  'nesselroeden': { name: 'Nesselröden', type: 'Ortsteil', distance: 28, region: 'Duderstadt' },
  'tiftlingerode': { name: 'Tiftlingerode', type: 'Ortsteil', distance: 24, region: 'Duderstadt' },
  'westerode': { name: 'Westerode', type: 'Ortsteil', distance: 26, region: 'Duderstadt' },
  'werxhausen': { name: 'Werxhausen', type: 'Ortsteil', distance: 27, region: 'Duderstadt' },
  // Gieboldehausen
  'gieboldehausen': { name: 'Gieboldehausen', type: 'Flecken', distance: 20, region: 'Landkreis Göttingen' },
  'bilshausen': { name: 'Bilshausen', type: 'Ortsteil', distance: 22, region: 'Gieboldehausen' },
  'bodensee': { name: 'Bodensee', type: 'Ortsteil', distance: 23, region: 'Gieboldehausen' },
  'germershausen': { name: 'Germershausen', type: 'Ortsteil', distance: 21, region: 'Gieboldehausen' },
  'krebeck': { name: 'Krebeck', type: 'Ortsteil', distance: 19, region: 'Gieboldehausen' },
  'obernfeld': { name: 'Obernfeld', type: 'Ortsteil', distance: 24, region: 'Gieboldehausen' },
  'renshausen': { name: 'Renshausen', type: 'Ortsteil', distance: 22, region: 'Gieboldehausen' },
  'rollshausen': { name: 'Rollshausen', type: 'Ortsteil', distance: 20, region: 'Gieboldehausen' },
  'wollershausen': { name: 'Wollershausen', type: 'Ortsteil', distance: 21, region: 'Gieboldehausen' },
  'wollbrandshausen': { name: 'Wollbrandshausen', type: 'Ortsteil', distance: 23, region: 'Gieboldehausen' },
  // Rüdershausen / Rhumspringe
  'ruedershausen': { name: 'Rüdershausen', type: 'Gemeinde', distance: 18, region: 'Landkreis Göttingen' },
  'rhumspringe': { name: 'Rhumspringe', type: 'Gemeinde', distance: 16, region: 'Landkreis Göttingen' },
  'poetzelsau': { name: 'Pötzelsau', type: 'Ortsteil', distance: 17, region: 'Rhumspringe' },
  // Seeburg
  'seeburg': { name: 'Seeburg', type: 'Flecken', distance: 18, region: 'Landkreis Göttingen' },
  'bernshausen': { name: 'Bernshausen', type: 'Ortsteil', distance: 19, region: 'Seeburg' },
  // Herzberg
  'herzberg': { name: 'Herzberg am Harz', type: 'Stadt', distance: 30, region: 'Landkreis Göttingen' },
  'poehlde': { name: 'Pöhlde', type: 'Ortsteil', distance: 28, region: 'Herzberg' },
  'scharzfeld': { name: 'Scharzfeld', type: 'Ortsteil', distance: 29, region: 'Herzberg' },
  'sieber': { name: 'Sieber', type: 'Ortsteil', distance: 30, region: 'Herzberg' },
  // Wulften
  'wulften': { name: 'Wulften am Harz', type: 'Gemeinde', distance: 22, region: 'Landkreis Göttingen' },
  'lindau-harz': { name: 'Lindau (Harz)', type: 'Ortsteil', distance: 24, region: 'Wulften' },
  // Osterode
  'osterode': { name: 'Osterode am Harz', type: 'Stadt', distance: 28, region: 'Landkreis Göttingen' },
  'dorste': { name: 'Dorste', type: 'Ortsteil', distance: 26, region: 'Osterode' },
  'schwiegershausen': { name: 'Schwiegershausen', type: 'Ortsteil', distance: 25, region: 'Osterode' },
  'lasfelde': { name: 'Lasfelde', type: 'Ortsteil', distance: 27, region: 'Osterode' },
  // Hattorf
  'hattorf': { name: 'Hattorf am Harz', type: 'Gemeinde', distance: 20, region: 'Landkreis Göttingen' },
  'woerden': { name: 'Wörden', type: 'Ortsteil', distance: 22, region: 'Hattorf' },
  // Walkenried
  'walkenried': { name: 'Walkenried', type: 'Gemeinde', distance: 30, region: 'Landkreis Göttingen' },
  'wieda': { name: 'Wieda', type: 'Ortsteil', distance: 29, region: 'Walkenried' },
  'zorge': { name: 'Zorge', type: 'Ortsteil', distance: 30, region: 'Walkenried' },
  // Bad Lauterberg / Bad Sachsa
  'bad-lauterberg': { name: 'Bad Lauterberg', type: 'Stadt', distance: 28, region: 'Landkreis Göttingen' },
  'barbis': { name: 'Barbis', type: 'Ortsteil', distance: 27, region: 'Bad Lauterberg' },
  'bartolfelde': { name: 'Bartolfelde', type: 'Ortsteil', distance: 29, region: 'Bad Lauterberg' },
  'bad-sachsa': { name: 'Bad Sachsa', type: 'Stadt', distance: 30, region: 'Landkreis Göttingen' },
  // Weitere Northeim
  'lagershausen': { name: 'Lagershausen', type: 'Ortsteil', distance: 6, region: 'Nörten-Hardenberg' },
  'ertinghausen': { name: 'Ertinghausen', type: 'Ortsteil', distance: 10, region: 'Hardegsen' },
  'hettensen': { name: 'Hettensen', type: 'Ortsteil', distance: 12, region: 'Hardegsen' },
  'lichtenborn': { name: 'Lichtenborn', type: 'Ortsteil', distance: 11, region: 'Hardegsen' },
  'ueschausen': { name: 'Üssinghausen', type: 'Ortsteil', distance: 13, region: 'Hardegsen' },
  'hevensen': { name: 'Hevensen', type: 'Ortsteil', distance: 9, region: 'Hardegsen' },
  'thoernerhoef': { name: 'Thörnerhoef', type: 'Ortsteil', distance: 11, region: 'Hardegsen' },
  'salzderhelden': { name: 'Salzderhelden', type: 'Ortsteil', distance: 22, region: 'Einbeck' },
  'drueberberg': { name: 'Drüber', type: 'Ortsteil', distance: 24, region: 'Einbeck' },
  'wenzen': { name: 'Wenzen', type: 'Ortsteil', distance: 26, region: 'Einbeck' },
  'naensen': { name: 'Naensen', type: 'Ortsteil', distance: 28, region: 'Einbeck' },
  'kuventhal': { name: 'Kuventhal', type: 'Ortsteil', distance: 23, region: 'Einbeck' },
  'volksen': { name: 'Volksen', type: 'Ortsteil', distance: 25, region: 'Einbeck' },
  'stroit': { name: 'Stroit', type: 'Ortsteil', distance: 24, region: 'Einbeck' },
  'hullersen': { name: 'Hullersen', type: 'Ortsteil', distance: 23, region: 'Einbeck' },
  'andershausen': { name: 'Andershausen', type: 'Ortsteil', distance: 27, region: 'Einbeck' },
  'berwartshausen': { name: 'Berwartshausen', type: 'Ortsteil', distance: 11, region: 'Northeim' },
  'edesheim': { name: 'Edesheim', type: 'Ortsteil', distance: 12, region: 'Northeim' },
  'hammenstedt': { name: 'Hammenstedt', type: 'Ortsteil', distance: 14, region: 'Northeim' },
  'hohnstedt': { name: 'Hohnstedt', type: 'Ortsteil', distance: 13, region: 'Northeim' },
  'stoeickheim': { name: 'Stöckheim', type: 'Ortsteil', distance: 15, region: 'Northeim' },
  'sebexen': { name: 'Sebexen', type: 'Ortsteil', distance: 26, region: 'Kalefeld' },
  'oldershausen': { name: 'Oldershausen', type: 'Ortsteil', distance: 27, region: 'Kalefeld' },
  'westerhof': { name: 'Westerhof', type: 'Ortsteil', distance: 28, region: 'Kalefeld' },
  'echte': { name: 'Echte', type: 'Ortsteil', distance: 24, region: 'Kalefeld' },
  'willershausen': { name: 'Willershausen', type: 'Ortsteil', distance: 25, region: 'Kalefeld' },
  // Göttingen Umland
  'seulingen': { name: 'Seulingen', type: 'Gemeinde', distance: 22, region: 'Landkreis Göttingen' },
  'esplingerode': { name: 'Esplingerode', type: 'Ortsteil', distance: 24, region: 'Seulingen' },
  'weissenborn': { name: 'Weißenborn', type: 'Ortsteil', distance: 23, region: 'Seulingen' },
  'radolfshausen': { name: 'Radolfshausen', type: 'Gemeinde', distance: 19, region: 'Landkreis Göttingen' },
  'waake': { name: 'Waake', type: 'Ortsteil', distance: 17, region: 'Radolfshausen' },
  'boeckeln': { name: 'Böckeln', type: 'Ortsteil', distance: 18, region: 'Radolfshausen' },
  'landolfshausen': { name: 'Landolfshausen', type: 'Gemeinde', distance: 20, region: 'Landkreis Göttingen' },
  'mackenrode': { name: 'Mackenrode', type: 'Ortsteil', distance: 21, region: 'Landolfshausen' },
  'herberhausen': { name: 'Herberhausen', type: 'Ortsteil', distance: 14, region: 'Göttingen' },
  'hetjershausen': { name: 'Hetjershausen', type: 'Ortsteil', distance: 15, region: 'Göttingen' },
  'knutbuehren': { name: 'Knutbühren', type: 'Ortsteil', distance: 16, region: 'Göttingen' },
  'deppoldshausen': { name: 'Deppoldshausen', type: 'Ortsteil', distance: 13, region: 'Göttingen' },
  'grosse-lengden': { name: 'Groß Lengden', type: 'Ortsteil', distance: 16, region: 'Gleichen' },
  'klein-lengden': { name: 'Klein Lengden', type: 'Ortsteil', distance: 15, region: 'Gleichen' },
  'rittmarshausen': { name: 'Rittmarshausen', type: 'Ortsteil', distance: 18, region: 'Gleichen' },
  'sattenhausen': { name: 'Sattenhausen', type: 'Ortsteil', distance: 17, region: 'Gleichen' },
  'weissenborn-goettingen': { name: 'Weißenborn (Göttingen)', type: 'Ortsteil', distance: 14, region: 'Gleichen' },
  // Rosdorf
  'mengershausen': { name: 'Mengershausen', type: 'Ortsteil', distance: 16, region: 'Rosdorf' },
  'lemshausen': { name: 'Lemshausen', type: 'Ortsteil', distance: 17, region: 'Rosdorf' },
  'dahlenrode': { name: 'Dahlenrode', type: 'Ortsteil', distance: 18, region: 'Rosdorf' },
  'volkerode': { name: 'Volkerode', type: 'Ortsteil', distance: 16, region: 'Rosdorf' },
  'settmarshausen': { name: 'Settmarshausen', type: 'Ortsteil', distance: 15, region: 'Rosdorf' },
  'obernjesa': { name: 'Obernjesa', type: 'Ortsteil', distance: 14, region: 'Rosdorf' },
  // Friedland
  'stockhausen': { name: 'Stockhausen', type: 'Ortsteil', distance: 22, region: 'Friedland' },
  'deiderode': { name: 'Deiderode', type: 'Ortsteil', distance: 20, region: 'Friedland' },
  'mollenfelde': { name: 'Mollenfelde', type: 'Ortsteil', distance: 21, region: 'Friedland' },
  'reckershausen': { name: 'Reckershausen', type: 'Ortsteil', distance: 23, region: 'Friedland' },
  'ludolfshausen': { name: 'Ludolfshausen', type: 'Ortsteil', distance: 19, region: 'Friedland' },
  'elkershausen': { name: 'Elkershausen', type: 'Ortsteil', distance: 18, region: 'Friedland' },
  'lichtenhagen': { name: 'Lichtenhagen', type: 'Ortsteil', distance: 24, region: 'Friedland' },
  // Hann. Münden
  'hedemmuenden': { name: 'Hedemünden', type: 'Ortsteil', distance: 26, region: 'Hann. Münden' },
  'gimte': { name: 'Gimte', type: 'Ortsteil', distance: 27, region: 'Hann. Münden' },
  'laubach': { name: 'Laubach', type: 'Ortsteil', distance: 28, region: 'Hann. Münden' },
  'oberode': { name: 'Oberode', type: 'Ortsteil', distance: 29, region: 'Hann. Münden' },
  'bonaforth': { name: 'Bonaforth', type: 'Ortsteil', distance: 26, region: 'Hann. Münden' },
  'volkmarshausen': { name: 'Volkmarshausen', type: 'Ortsteil', distance: 27, region: 'Hann. Münden' },
  'wiershausen': { name: 'Wiershausen', type: 'Ortsteil', distance: 25, region: 'Hann. Münden' },
  // Dransfeld
  'varmissen': { name: 'Varmissen', type: 'Ortsteil', distance: 19, region: 'Dransfeld' },
  'barlissen': { name: 'Barlissen', type: 'Ortsteil', distance: 20, region: 'Dransfeld' },
  'ossenfeld': { name: 'Ossenfeld', type: 'Ortsteil', distance: 18, region: 'Dransfeld' },
  'atzenhausen': { name: 'Atzenhausen', type: 'Ortsteil', distance: 17, region: 'Dransfeld' },
  'meensen': { name: 'Meensen', type: 'Ortsteil', distance: 21, region: 'Dransfeld' },
  'juehnde': { name: 'Jühnde', type: 'Gemeinde', distance: 14, region: 'Landkreis Göttingen' },
  'barlissen-dransfeld': { name: 'Bördel', type: 'Ortsteil', distance: 16, region: 'Dransfeld' },
};

// Service names for cross-referencing
export const SERVICE_NAMES = {
  'gartenpflege': 'Gartenpflege',
  'erdarbeiten': 'Erdarbeiten',
  'baumfaellung': 'Baumfällung',
  'hochdruckreinigung': 'Hochdruckreinigung',
  'entsorgung': 'Gartenbau',
};

// Get cities only (no Ortsteile)
export const getCities = () => 
  Object.entries(LOCATIONS)
    .filter(([, loc]) => loc.type !== 'Ortsteil')
    .sort((a, b) => a[1].distance - b[1].distance);

// Get all locations sorted by distance
export const getAllLocationsSorted = () =>
  Object.entries(LOCATIONS).sort((a, b) => a[1].distance - b[1].distance);

// Alle Ortsnamen, die inhaltlich zu einer Stadt gehoeren:
// der Stadtname selbst plus die Namen aller zugehoerigen Ortsteile.
// Wird genutzt, damit ein Projekt aus einem Ortsteil (z.B. Lenglern) auch
// auf der Seite der uebergeordneten Stadt (Bovenden) erscheint - die
// Ortsteil-Seiten selbst werden per 301 dorthin weitergeleitet.
export const getLocationNamesForCity = (citySlug) => {
  const city = LOCATIONS[citySlug];
  if (!city) return [];

  // Namensvarianten mit aufnehmen: im Admin wird ein Projekt oft nur mit
  // "Wulften" erfasst, waehrend die Ortsdatenbank "Wulften am Harz" fuehrt.
  const withVariants = (name) => {
    const variants = new Set([name]);
    variants.add(name.replace(/ am Harz$/, ''));
    variants.add(name.replace(/ \(.*\)$/, ''));
    return [...variants];
  };

  const names = withVariants(city.name);
  Object.values(LOCATIONS).forEach((loc) => {
    if (loc.type === 'Ortsteil' && loc.region === city.name) {
      names.push(...withVariants(loc.name));
    }
  });
  return [...new Set(names)];
};

// Get locations by region
export const getLocationsByRegion = () => {
  const regions = {};
  Object.entries(LOCATIONS).forEach(([slug, loc]) => {
    const region = loc.region;
    if (!regions[region]) regions[region] = [];
    regions[region].push({ slug, ...loc });
  });
  return regions;
};
